<template>

  <div :class="['hq_table hq_table_' + name]"
    :style="{width: tableWidth}">
    <div :class="['hq_thead hq_thead_' + name]">
        <hqthead :sort="sort" :theadN="theadN"></hqthead>
    </div>
	
    <div :class="['hq_tbody', 'hq_tbody_' + name]" v-if="!subset" :style="{'padding-top':virtualTopHeight,'padding-bottom':virtualBottomHeight}">
        <!-- 无子集的dom结构 -->
        <template v-if="!subset">
            <div v-for="(idx, i) in indexList" 
                :key="'tr_' + i"
                :class="['hq_tr', 
                    activeIndex == idx && 'hq_tr_active',
                    hoverIndex === idx && trHoverClass]" 
                :idx="idx" >
                <div v-for="(td,j) in theadN"
                    :key="'td_' + j"
                    :class="['hq_td', td.events && 'td_events']"
                    :td-key="td.key"
                    :style="{width: getTdWidth(td)}"
                    v-html="td.format(td.key !== 'index' ? dataMap[idx][td.key] : (+i+1), dataMap[idx], idx)"></div>
                <slot name="extend_tr" :idx="idx" :data="dataMap[idx]"></slot>
            </div>
        </template>
        <slot name="nodata" v-if="!indexList || indexList.length === 0">
            <div style="width:100%; padding:100px 0;" >暂无数据</div>
        </slot>
    </div>
    <template v-if="subset">
        <div v-for="(idx, i) in indexList" 
            :key="'subset_' + i"
            :class="['hq_tr_wrap', dataMap[idx]['subState'] && 'hq_tr_subshow']" >
            <div :class="['hq_tr', 
                        activeIndex == idx && 'hq_tr_active',
                        hoverIndex === idx && trHoverClass]" 
                :idx="idx">
                <div v-for="(td,j) in theadN"
                    :key="'td_' + j"
                    :class="['hq_td', td.events && 'td_events']"
                    :td-key="td.key"
                    :style="{width: getTdWidth(td)}"
                    v-html="td.format(td.key !== 'index' ? dataMap[idx][td.key] : (+i+1), dataMap[idx], idx)">
                </div>
                <slot name="extend_tr" :idx="idx" :data="dataMap[idx]"></slot>
            </div>

            <div v-for="(subIdx, subi) in subsetIndexList[idx]" 
                :key="'subi_' + subi"
                :class="['hq_tr_subset', 
                        activeIndex == subIdx && 'hq_tr_active',
                        hoverIndex === idx && trHoverClass]" 
                v-show="dataMap[idx]['subState']"
                :idx="subIdx">
                <div v-for="(td,i) in theadN"
                    :key="'td_' + i"
                    :class="['hq_td_subset', td.events && 'td_events']"
                    :td-key="td.key"
                    :style="{width: getTdWidth(td)}"
                    v-html="td.format(td.key !== 'index' ? dataMap[subIdx][td.key] : (+subi+1), dataMap[subIdx], subIdx)">
                </div>
                <slot name="extend_tr" :idx="subIdx" :data="dataMap[subIdx]"></slot>
            </div>
        </div>
    </template>
    <!-- 每个表格底部暴露一块出去 -->
    <slot name="extend"></slot>
   
  </div>
</template>

<script>
import Hqthead from './thead.vue'
import Util from './util'
export default {
  name: 'htable',
  props: ['sort', 'theadN', 'tableWidth', 'subset', 'indexList', 'activeIndex', 'dataMap', 'subsetIndexList', 'name', 'hoverIndex', 'trHoverClass','virtualTopHeight','virtualBottomHeight'],
  components: {
      Hqthead
  },
  methods: {
    handleSort () {
      this.$parent.handleSort.call(this, arguments[0])
    },
    getTdWidth: Util.getTdWidth
  }
}
</script>

<style>
  .hq_tr_wrap {
    /* display: table-row-group; */
    vertical-align: middle;
    border-color: inherit;
  }
</style>




// WEBPACK FOOTER //
// src/lib/v-hqtable/lib/table.vue